import React, { useEffect, useState } from "react";
import WebIcon from "@mui/icons-material/Web";

// JS Files
import AppDownloadCard from "./AppDownloadCard";

// Others File
import appLogo from "../../imgs/app.svg";

import anardooniIcon from "../../imgs/anardoni-icon.svg";
import anardooniName from "../../imgs/anardoni-name.svg";
import android from "../../imgs/android.svg";
import apple from "../../imgs/apple.svg";
import web from "../../imgs/web.svg";

import itipsIcon from "../../imgs/itips-logo.svg";
import itipsName from "../../imgs/itips-name.svg";
import { APP_API_URL } from "../../constants/constants";

const AppDownload = () => {
  const [links, setLinks] = useState({ customer_app: null });
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch(`${APP_API_URL}/api/app/commons/app_link/?insurance_code=REF`)
      .then((response) => response.json())
      .then((data) => setLinks(data));
  }, []);

  return (
    <>
      <div className="mx-4 md:mx-32 mb-2 mt-10 md:mt-20 grid md:grid-cols-2 items-center">
        <div className="">
          <img src={appLogo} />
        </div>
        <div className="text-center md:text-right">
          <p className="text-lg font-bold text-mygray-700">
            دانلود اپلیکیشن رفاپ
          </p>
          <p className="text-sm leading-8 mt-4 text-mygray-500">
            به منظور استفاده اپلیکیشن رفاپ، می‌توانید این اپلیکیشن را از طریق
            لینک‌های زیر دانلود نمایید.
          </p>
          <div className="grid md:grid-cols-2 gap-4 mt-8">
            <AppDownloadCard
              icon={android}
              header="دانلود نسخه اندروید از طریق"
              text="لینک مستقیم"
              link={links}
            />
            {/* <AppDownloadCard
              icon={itipsIcon}
              header="دانلود نسخه ios از"
              isIcon
              nameIcon={itipsName}
            />
            <AppDownloadCard
              icon={anardooniIcon}
              header="دانلود نسخه ios از"
              isIcon
              nameIcon={anardooniName}
            /> */}
            <AppDownloadCard
              icon={web}
              header="مناسب برای کاربران وب و ios"
              text="نسخه وب‌اپلیکیشن"
              pwaLink="https://pwa.rfap.ir"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default AppDownload;
